import { dec } from '@app/shared';

/** Итог разбора введённого текста: значение либо причина отказа. Пустое поле — не ошибка. */
export interface ParsedInput<T> {
  value: T | null;
  error: string | null;
}

/** Больше — почти наверняка опечатка (лишние нули), а количество должно умещаться в целое БД. */
const MAX_INT = 1_000_000;

/**
 * Целое число (коробки, штук в коробке). Неверный ввод не исправляется: «1,5» не становится 15, а
 * «0» — единицей. Поле остаётся с тем, что ввели, наружу уходит «пусто», владелец видит причину.
 */
export function parseIntInput(raw: string, min: number): ParsedInput<number> {
  const text = raw.trim();
  if (text === '') return { value: null, error: null };
  if (/^-\d+([.,]\d+)?$/.test(text)) return { value: null, error: min > 0 ? `Число должно быть не меньше ${min}` : 'Число не может быть отрицательным' };
  if (!/^\d+$/.test(text)) return { value: null, error: 'Нужно целое число, без дробной части' };
  const value = parseInt(text, 10);
  if (value < min) return { value: null, error: `Число должно быть не меньше ${min}` };
  if (value > MAX_INT) return { value: null, error: 'Слишком большое число' };
  return { value, error: null };
}

/** Денежная сумма: неотрицательная, до двух знаков; запятая — то же, что точка (§1). */
export function parseMoneyInput(raw: string): ParsedInput<string> {
  const text = raw.trim().replace(',', '.');
  if (text === '') return { value: null, error: null };
  if (/^-\d*\.?\d*$/.test(text)) return { value: null, error: 'Сумма не может быть отрицательной' };
  if (/^\d+\.\d{3,}$/.test(text)) return { value: null, error: 'Не больше двух знаков после запятой' };
  if (!/^(\d{1,12}(\.\d{0,2})?|\.\d{1,2})$/.test(text)) return { value: null, error: 'Нужно число: например, 1250 или 1250,50' };
  return { value: dec(text.startsWith('.') ? `0${text}` : text).toFixed(2), error: null };
}
